import { render, staticRenderFns } from "./question-bundle-entrepreneur-starting-page.vue?vue&type=template&id=1a4e10e0&scoped=true&"
import script from "./question-bundle-entrepreneur-starting-page.vue?vue&type=script&lang=ts&"
export * from "./question-bundle-entrepreneur-starting-page.vue?vue&type=script&lang=ts&"
import style0 from "./question-bundle-entrepreneur-starting-page.vue?vue&type=style&index=0&id=1a4e10e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e10e0",
  null
  
)

export default component.exports